import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

/**
 * Reads a named query string parameter once on mount, caches the value,
 * and removes it from the URL via history.replace to keep the address
 * bar clean without desynchronizing React Router.
 *
 * Returns the captured value (string) or null if the parameter was absent
 * or paramName is falsy.
 */
export default function useConsumeQueryParam (paramName) {
  const history = useHistory()

  const [value] = useState(() => {
    if (!paramName) return null
    const params = new URLSearchParams(window.location.search)
    return params.get(paramName) ?? null
  })

  useEffect(() => {
    if (!paramName || value === null) return
    const searchParams = new URLSearchParams(history.location.search)
    if (searchParams.has(paramName)) {
      searchParams.delete(paramName)
      history.replace({ search: searchParams.toString() })
    }
  }, [paramName, value, history])

  return value
}
